export default "__VITE_ASSET__63e593e7__"